import {FormHelpers} from "./helpers/form-helpers";
import {Helpers} from "./helpers/helpers";
import {Category, FilterParameter, SearchResults} from "./models/types";
import {FilterableList} from "./filterable-list";
import {isNumber} from "lodash-es";


export class Search {
	private searchWrapper: HTMLElement;
	private searchItemTemplate: HTMLElement;
	private totalResults: HTMLElement;
	private currentResults: HTMLElement;
	private paginationContainer: HTMLElement;
	
	private filterWrapper: HTMLElement;
	private noResultsWrapper: Element;
	private searchActions: Element;

	private currentPageIndex: number = 1;
	private pageSize = 15;
	private searchText = "";
	private searchQueryWrapper: HTMLElement;
	private resultsFor: Element;
	private selectedFilterList: HTMLElement;
	private searchWidget: HTMLElement;
	private initialLoadFromSearchWidget: boolean;
	
	constructor() {
		this.searchWrapper = document.querySelector('.search-results') as HTMLElement;
		this.searchItemTemplate = document.querySelector('.search-item-template') as HTMLElement;
		this.totalResults = document.querySelector('.total-results') as HTMLElement;
		this.currentResults = document.querySelector('.current-results') as HTMLElement;
		this.paginationContainer = document.querySelector('.pagination-container') as HTMLElement;
		this.filterWrapper = document.querySelector('.search-filters') as HTMLElement;
		this.noResultsWrapper = document.querySelector('.no-results');
		this.resultsFor = document.querySelector('.result-for span');
		this.searchActions = document.querySelector('.search-actions');
		this.searchQueryWrapper = document.querySelector('.search-query-filter-form ') as HTMLElement;
		this.selectedFilterList = document.querySelector('.selected-filter-list') as HTMLElement;
		this.searchWidget = document.querySelector('.search-widget');
		
		
		if (!Helpers.isNullOrUndefined(this.searchWidget)) {
			//search widget
			this.setupSearchWidget();
		}
		
		
		if (!Helpers.isNullOrUndefined(this.searchWrapper)  && !Helpers.isNullOrUndefined(this.searchQueryWrapper))
		{
			const urlParams = Helpers.getUrlParameters();
			
			this.initialLoadFromSearchWidget = urlParams["searchWidget"] ? urlParams["searchWidget"] === 'true' : false; 
			//search page
			this.setupFilters();
			this.setupSearchQuery();
			this.initPagination();

			
			if (urlParams && urlParams["filters"]) {
				this.setFilterCheckboxes();
			}
		}
		
		
		
	}

	private setupFilters() {
		const filterCheckboxes = document.querySelectorAll('.filter-list input[type=checkbox]');

		filterCheckboxes.forEach((checkbox) => {
			checkbox.addEventListener('click', e => {
				this.initialLoadFromSearchWidget = false;				
				this.search(true);
			});
		});
	}

	setFilterCheckboxes() {
		const parameters = Helpers.getUrlParameters();

		document.querySelector('.section-expandable.expanded')?.classList.remove('expanded');
		//set checkboxes to checked based on URL parameters
		if (Object.prototype.hasOwnProperty.call(parameters,"filters")) {
			const filterGroups: string[] = parameters["filters"].split("_");
			filterGroups.forEach(group => {
				const parentId = group.split("-")[0];				
				if (parentId === 'PageType') {

					const types = group.split("-");
					const resourceTypes = ["Download", "FAQ", "Video", "Webinar", "Article", "Event", "ResourceGroup"];
					const typeList = this.filterWrapper.querySelector('.filter-list[data-category="' + parentId + '"]');
					types.forEach(pageType => {
						if (resourceTypes.indexOf(pageType) !== -1) {
							pageType = "ResourceGroup";
						} else {
							pageType = "Tensar." + pageType;
						}
						
						const checkbox = typeList.querySelector('input[type=checkbox][value="'+pageType+'"]');
						if (checkbox) {						
							
							(checkbox as HTMLInputElement).checked = true;
						}
					});
				} else {
					const categoryIds = group.split("-");
					
					const categoryList = this.filterWrapper.querySelector('.filter-list[data-category="' + parentId + '"] .category-list');
					if (categoryList) {
						categoryIds.forEach(id => {
							if (!isNaN(parseInt(id))) {
								const checkbox = categoryList.querySelector('input[type=checkbox][value="' + id + '"]');
								(checkbox as HTMLInputElement).checked = true;
							}
						});
					}
				}
			});
			
		}
		if (parameters["page"]) {
			this.currentPageIndex = parseInt(parameters["page"]);
		}	

		this.search();
	}

	toggleLoader(isLoading: boolean): void {
		const loader = document.querySelector('.search-page .loader');
		if (Helpers.isNullOrUndefined(loader)) return;
		if (isLoading) {
			loader.classList.remove('d-none');
		} else {
			loader.classList.add('d-none');
			//this.resultsWrapper.classList.remove('d-none');
			this.paginationContainer.classList.remove('d-none');
		}
	}

	private search(resetPage = false) {
		if (resetPage) {
			this.currentPageIndex = 1;
		}
		
		const pageTypeFilters = document.querySelectorAll('.page-type-filters input[type=checkbox]:checked') as NodeListOf<HTMLInputElement>;
		let pageTypeFiles =  Array.from(pageTypeFilters).map((checkbox: HTMLInputElement) => checkbox.value);
		
		let categoryFilters = this.getSelectedFilters();

		if (this.initialLoadFromSearchWidget) {
			const urlParameters = Helpers.getUrlParameters();
		
			const filterGroups: string[] = urlParameters["filters"].split("_");
			filterGroups.forEach(group => {
				const parentId = group.split("-")[0];
				if (parentId === 'Category') {
					categoryFilters = new Array<FilterParameter>();
					const categoryIds = group.split("-");
					console.log(categoryIds, 'IDS');
					let filter: FilterParameter =  {
						categoryIds: new Array<Category>(),
						categoryParent: "Category",
						codeName: "",
						countryCode: "",
						stateCode: ""
					}
					categoryIds.forEach(cat=> {
						if (!isNaN(Number(cat))) {
							let categoryId: Category = {
								id: parseInt(cat),
								displayName: ""
							}
							filter.categoryIds.push(categoryId);
						}
					});
					categoryFilters.push(filter);
				}
				
			});
			
		}
		
		const searchRequest = {
			pageIndex: this.currentPageIndex,
			filters: categoryFilters,
			culture: Helpers.getCurrentCulture(),
			documentTypes: pageTypeFiles,
			pageSize: this.pageSize,
			searchText: this.searchText			
		};
		this.toggleLoader(true);
		this.searchWrapper.innerHTML = "";
		this.noResultsWrapper.classList.add('d-none');
		this.searchActions.classList.remove('d-none');
		this.resultsFor.innerHTML = this.searchText;
		this.doSearch(searchRequest, (response)=> {
			this.updateResults(response);
		})	
		this.updateUrlWithFilters(categoryFilters, pageTypeFiles);
	}
	
	private doSearch(searchRequest: any, onSuccess:  (response: SearchResultsModel) => void) {
		FormHelpers.postAjax({
			url: "/search/all",
			data: searchRequest,
			success: (response) => {
				onSuccess(response);
				this.toggleLoader(false);
			},
			error: (response) => {
				console.log(response);
				this.toggleLoader(false);
			},
		});
	}

	public updateResults(results: SearchResultsModel) {
		
		if (!results || results.items.length === 0) {
			this.noResultsWrapper.classList.remove('d-none');			
			//this.searchWrapper.classList.add('d-none');
		}
	
		this.currentResults.innerHTML = results.currentDisplayAmount.toString();
		this.totalResults.innerHTML = results.totalCount.toString();
		
		results?.items?.forEach(result => {
			const template = this.searchItemTemplate.querySelector('.search-tile').cloneNode(true) as HTMLElement;

			const title = template.querySelector('h3 a') as HTMLAnchorElement;
			const type = template.querySelector('.pill-list ul');
			const content = template.querySelector('.search-content');


			title.innerHTML = result.title;
			title.href = result.url.replace("~", "");
			content.innerHTML = result.content;
			type.innerHTML = `<li>${result.type}</li>`

			this.searchWrapper.append(template);
		});

		this.updatePagination(results.currentPage, results.totalPages);

	}

	getSelectedFilters(): Array<FilterParameter> {
		const  categoryFilters = document.querySelectorAll('.category-list') as NodeListOf<HTMLElement>;

		const selectedFilters = new Array<FilterParameter>();
		categoryFilters.forEach(list => {
			let categoryParent = list.dataset.category;
			if (!categoryParent) {
				categoryParent  = list.parentElement.dataset.category;
			}
			if (categoryParent != "PageType") {			
				const categoryIds: Category[] = [];
				const filterParameter = {} as FilterParameter;
				const selectedCheckboxes = list.querySelectorAll("input[type=checkbox]:checked");

				selectedCheckboxes.forEach(checkbox => {
					const checkboxElement = checkbox as HTMLInputElement;
					const parentLabel = checkboxElement.closest('label');
					const category = {
						id: parseInt(checkboxElement.value),
						displayName: parentLabel.innerText
					}
					categoryIds.push(category);
				});

				if (categoryIds.length > 0) {
					filterParameter.categoryParent = categoryParent;
					filterParameter.categoryIds = categoryIds;
					selectedFilters.push(filterParameter);
				}
			}
		});

		return selectedFilters;
	}

	initPagination() {
		const parameters = Helpers.getUrlParameters();
		const perPageDropdown = document.querySelector('#search-per-page') as HTMLSelectElement;
		if (parameters['page']) {
			this.currentPageIndex = parseInt(parameters['page']);
		}
		if (parameters['pageSize']) {
			this.pageSize = parseInt(parameters['pageSize']);
		}

		perPageDropdown.addEventListener('change',(e)=> {
			const pageSize = perPageDropdown.value;
			this.pageSize = parseInt(pageSize);
			this.search();
		})
		
		this.paginationContainer?.addEventListener('click', (e) => {
			let clickedElement = (e.target as HTMLElement);

			if (clickedElement.tagName === 'A' || clickedElement.tagName === 'svg') {
				if (clickedElement.tagName === 'svg') {
					clickedElement = clickedElement.closest('a');
				}

				e.preventDefault();
				const pageNumber = clickedElement.dataset.pagenumber;
				this.currentPageIndex = parseInt(pageNumber);

				this.paginationContainer.querySelectorAll('li').forEach(li => { li.classList.remove('active'); });
				clickedElement.closest('li').classList.add('active');
				Helpers.scrollToElement(this.searchWrapper, 10, -200);

				this.search();
			}
		});
	}
	
	updateUrlWithFilters(parameters: Array<FilterParameter>, pageTypes: string[], returnValue = false, baseUrl = "/search/index?searchWidget=true") {
		const params = Helpers.getUrlParameters();
		if (params["searchWidget"] === 'true') return;
		let filterUrl: any = {};
		const queryString: string[] = [];
		if (parameters.length !== 0) {
			parameters.forEach(parameter => {
				let formattedFilterParameter = "";
				if (parameter.categoryIds.length) {
					formattedFilterParameter += parameter.categoryParent + "-";
					formattedFilterParameter += parameter.categoryIds.map(c => c.id).join("-");
					queryString.push(formattedFilterParameter);
				}
			});
		}

		if (pageTypes.length) {
			let pageTypesParam = `PageType-${pageTypes.map(p=>p.replace('Tensar.','')).join('-')}`;
			queryString.push(pageTypesParam);
		}

		if (queryString.length) {
			filterUrl["filters"] = queryString.join("_");
		}
		

		filterUrl["page"] = this.currentPageIndex;		
		filterUrl["pageSize"] = this.pageSize;		
		filterUrl["searchText"] = this.searchText;		
		
		//check other querystrings 
		const knownValues = ["page", "location","filters", "pageSize", "searchText"];
	
		knownValues.forEach(v=> delete params[v]);
		filterUrl = {...filterUrl, ...params};
		if (returnValue) {
			return Helpers.getUpdatedUrl(filterUrl, baseUrl);
		}
		Helpers.updateUrl(filterUrl);
	}
	
		
	private updatePagination(currentPage: number, totalPages: number) {
		PaginationHelpers.updatePagination(currentPage, totalPages, this.paginationContainer);
	}

	private setupSearchQuery() {
		const button = this.searchQueryWrapper.querySelector("button");
		const textBox = this.searchQueryWrapper.querySelector("#filter-search-query-field") as HTMLInputElement;
		
		const urlParameters = Helpers.getUrlParameters();
		if (urlParameters && urlParameters['searchText']) {
			this.searchText = urlParameters['searchText'];
			textBox.value = urlParameters.searchText;
		}
		
		const queryClicked = () => {
			this.searchText = textBox.value;
			this.search();
		};

		textBox?.addEventListener("keyup", function (event) {
			if (event.code === "Enter") {
				queryClicked();
			}
		});

		button?.addEventListener('click', (e) => {
			queryClicked();
		})

	}

	private setupSearchWidget() {
		const input = this.searchWidget.querySelector('.search-form input') as HTMLInputElement;
		const searchResultWrapper = this.searchWidget.querySelector('.search-results-wrapper');
		const loader = this.searchWidget.querySelector('.loading-container');
		const searchResultTemplate = this.searchWidget.querySelector('.search-result-template');
		const searchWrapper = this.searchWidget.querySelector('.search-results');
		const noResults = this.searchWidget.querySelector('.no-results');
		const pageTypes = this.searchWidget.dataset.pagetypes.split(',');
		const searchCategoryNames = this.searchWidget.dataset.categories.split(',').filter(c=>c!== '');
		const viewAllContainer = this.searchWidget.querySelector('.view-all');
		const viewAllButton = viewAllContainer.querySelector('a');
		let searchTimeout: NodeJS.Timeout = null;
		const filters = new Array<FilterParameter>();
		
		if (searchCategoryNames.length) {
	
			let filter: FilterParameter =  {
				categoryIds: new Array<Category>(),
				categoryParent: "Category",
				codeName: "",
				stateCode: "",
				countryCode: ""
			}
			searchCategoryNames.forEach(cat => {
				let catId = parseInt(cat);
				if (isNumber(catId)) {
					let categoryId: Category = {
						id:catId,
						displayName: ""
					}
					filter.categoryIds.push(categoryId);
				}
			});
			filters.push(filter);
		}
		
	
		
		input.addEventListener('keyup',(e)=>{
			if (e.code === "Enter") {
				return;
			}
			searchResultWrapper.classList.remove('d-none');
			loader.classList.remove('d-none');
			noResults.classList.add('d-none');
			viewAllContainer.classList.add('d-none');
			clearTimeout(searchTimeout);
			
			searchTimeout = setTimeout(()=>{

		
				const searchRequest = {
					pageIndex: 1,
					filters:  filters ?? new Array<FilterParameter>(),
					culture: Helpers.getCurrentCulture(),
					documentTypes: pageTypes ?? ["Tensar.Distributor", "Tensar.Article","Tensar.FAQ", "Tensar.Video", "Tensar.GenericPage"],
					pageSize: 4,
					searchText: input.value
				};
				
				this.doSearch(searchRequest, (response)=>{
					
					searchWrapper.innerHTML = "";
					if (!response || response.items.length === 0) {
						this.noResultsWrapper.classList.remove('d-none');
						this.searchActions?.classList.add('d-none');
						loader.classList.add('d-none');
						//this.searchWrapper.classList.add('d-none');
					}
					
					response.items.forEach(result => {
						const template =searchResultTemplate.querySelector('.search-tile').cloneNode(true) as HTMLElement;

						const title = template.querySelector('h3 a') as HTMLAnchorElement;
						const type = template.querySelector('.pill-list ul');
						const content = template.querySelector('.search-content');


						title.innerHTML = result.title;
						title.href = result.url.replace("~", "");
						content.innerHTML = result.content;
						type.innerHTML = `<li>${result.type}</li>`

						searchWrapper.append(template);
					});

					if (response.items.length === 0){
						noResults.classList.remove('d-none');
					} else {
						this.searchText = searchRequest.searchText;						
						const viewAllLink = this.updateUrlWithFilters(filters, searchRequest.documentTypes, true );
						viewAllButton.href = viewAllLink;
						viewAllContainer.classList.remove('d-none');
					}
					
					loader.classList.add('d-none');
				});
			},600);
			
		});
	
	}
}


export interface SearchResultItemModel {
	title: string;
	content: string;
	date: Date;
	objectType: string;
	type: string;
	imagePath: string;
	url: string;

}

export interface SearchResultsModel {
	query: string;
	items: SearchResultItemModel[];
	currentDisplayAmount: number;
	totalCount: number;
	totalPages: number;
	currentPage: number;
	
}

export class PaginationHelpers {
	public static updatePagination(currentPage: number, totalPages: number, paginationElement: HTMLElement) {
		if (paginationElement) {
			const ul = paginationElement.querySelector('ul');
			const nextLink = ul.querySelector('.next');
			const previousLink = ul.querySelector('.previous');
			const nextA = (nextLink.querySelector('a') as HTMLAnchorElement);
			const previousA = (previousLink.querySelector('a') as HTMLAnchorElement);


			ul.querySelectorAll('.page').forEach(l => { l.remove() });

			const liEllipses = document.createElement('li') as HTMLElement;
			liEllipses.classList.add("page");
			liEllipses.innerText = "...";
			let startPage = 1;
			let endPage = totalPages;
			if (totalPages > 10) {
				if (currentPage > 1) {
					startPage = currentPage - 1;
				}

				endPage = startPage + 9;
				if (endPage > totalPages) {
					startPage = totalPages - 9;
					endPage = totalPages;
				}

			}

			let nextPage = currentPage + 1;
			if (nextPage >= totalPages) {
				nextPage = totalPages;
			}
			let previousPage = currentPage - 1;
			if (previousPage < 0) {
				previousPage = 1;
			}

			if (previousPage >= totalPages) {
				previousPage = totalPages - 1;
			}


			nextA.href = '?page=' + (nextPage);
			nextA.dataset.pagenumber = (nextPage).toString();
			previousA.href = '?page=' + (previousPage);
			previousA.dataset.pagenumber = (previousPage).toString();

			if (totalPages > endPage && currentPage > 10) {
				const li = document.createElement('li') as HTMLElement;
				const a = document.createElement('a') as HTMLAnchorElement;
				a.dataset.pagenumber = "1";
				a.href = '?page=1';
				a.innerText = "1";
				li.classList.add("page");
				li.append(a);
				ul.insertBefore(li, nextLink);
				ul.insertBefore(liEllipses.cloneNode(true), nextLink);

			}

			for (let i = startPage; i <= endPage; i++) {
				const li = document.createElement('li') as HTMLElement;
				const a = document.createElement('a') as HTMLAnchorElement;
				a.dataset.pagenumber = i.toString();
				a.href = '?page=' + i;
				a.innerText = i.toString();
				li.classList.add("page");
				li.append(a);
				if (currentPage === i) {
					li.classList.add('active'); }
				ul.insertBefore(li, nextLink);
			}


			if (totalPages > endPage) {
				const li = document.createElement('li') as HTMLElement;
				const a = document.createElement('a') as HTMLAnchorElement;
				a.dataset.pagenumber = totalPages.toString();
				a.href = '?page=' + totalPages;
				a.innerText = totalPages.toString();
				li.classList.add("page");
				li.append(a);
				ul.insertBefore(liEllipses.cloneNode(true), nextLink);
				ul.insertBefore(li, nextLink);


			}

			if (totalPages > 1 && totalPages > currentPage) {
				nextLink?.classList.remove('d-none');
			} else {
				nextLink?.classList.add('d-none');
			}

			if (totalPages > 1 && currentPage > 1) {
				previousLink?.classList.remove('d-none');
			} else {
				previousLink?.classList.add('d-none');
			}
		}
	}
}



